import { trimDecimalPlaces } from "./numbers"

export function calculateLiveweightGain (nextSeasonWeight: number | undefined, currentSeasonWeight: number | undefined) {
  if (!currentSeasonWeight || !nextSeasonWeight) return 0
  if (currentSeasonWeight === 0 || nextSeasonWeight === 0) return 0
  return trimDecimalPlaces((nextSeasonWeight - currentSeasonWeight) / 91.25)
}